import "babel-polyfill";
import Vue from "vue";

import SwHic, { App } from "sw-hic";
import "sw-hic/sw-hic.css";
import SwHicPatient from "@sunway/patient";
import SwHicHospitalization from "@sunway/hospitalization";
import SwHicMasterData from "@sunway/masterdata";
import store from "@/common/store";
import router from "@/common/router";

Vue.config.productionTip = false;

if (process.env.NODE_ENV == "development") {
  // 引入mockjs
  // require('./common/mock.js')
}
Vue.use(SwHic);
Vue.use(SwHicPatient);
Vue.use(SwHicHospitalization);
Vue.use(SwHicMasterData);

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
